import React from 'react';
import './PropertySearch.css'
import '../../root.css'
import SearchInput from '../Common/SearchInput';
import MainBtn from '../Common/Btn';

const PropertySearch = () => {
    return ( 
        <div className='PropertySearch'>
            <p className='PSearchTitle'>Search for Available Properties</p>

            <div className='PSearchBtns'>
                <SearchInput InputText="Location"/>
                <SearchInput InputText="Property Type"/>
                <SearchInput InputText="Budget"/>
                <MainBtn btnStyle="searchBtn" btnText="Search.."/>
            </div>
        </div>
        
     );
}
 
export default PropertySearch;